import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../../services/api.service'; // <-- ชี้ไปยัง path ของคุณ
import { catchError, of } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

export const authGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  if (cookieService.get('must_change_password') === '1') {
    router.navigate(['/login']);
    return of(false);
  }

  return api.checkLogin().pipe(
    catchError(() => {
      cookieService.delete('token', '/');
      cookieService.delete('user_id', '/');
      cookieService.delete('username', '/');
      cookieService.delete('name', '/');
      cookieService.delete('company_id', '/');
      cookieService.delete('must_change_password', '/');
      cookieService.deleteAll('/');
      router.navigate(['/login']);
      return of(false);
    })
  );
};
